import { GraphAuthService } from '../../../../../app/modules/microsoft-graph/auth/services/graph-auth.service';

(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('emailView', {
        templateUrl: 'views/components/views/emailView/emailView.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'layoutService', 'stateService', 'base64', 'modalService', 'translateService', 'emailViewService', function ($stateParams, layoutService, stateService, base64, modalService, translateService, emailViewService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let emailKeyno = $stateParams.email_keyno;
            let onDestroy = [];

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                viewEmail: {},
                itemsListAttachments: [],
                replies: [],
                lockedDelete: false
            };

            vm.style = {
                subject: {},
                emailBody: {
                    message: {
                        backgroundColor: 'white'
                    }
                },
                senderInfo: {},
            }

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION SERVICE

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEmail() {
                vm.model.viewEmail = (await emailViewService.getEmailView(emailKeyno))[0];
                //vm.model.viewEmail.body = base64.urldecode(vm.model.viewEmail.body);
                //const iframe = document.getElementById('w-email__iframe');
                //const iframeDoc = iframe.contentDocument;
                //iframeDoc.open();
                //iframeDoc.write(vm.model.viewEmail.body);
                //iframeDoc.close();

                //setTimeout(() => iframe.style.height = iframeDoc.documentElement.querySelector('body').scrollHeight + 'px', 50);
                //return vm.model.viewEmail;
            }

            async function loadEmailAttachments() {
                if (!vm.model.viewEmail?.email_keyno) return vm.model.itemsListAttachments = [];
                return vm.model.itemsListAttachments = await emailViewService.listEmailViewAttachments(vm.model.viewEmail.email_keyno);
            }

            async function loadReplyToList() {
                if (!vm.model.viewEmail?.email_keyno) return vm.model.replies = [];
                return vm.model.replies = (await emailViewService.getReplyToList(vm.model.viewEmail.email_keyno));
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    emailViewService.deleteItem(vm.model.viewEmail).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        }
                    }, () => {
                        vm.model.lockedDelete = false;
                    });
                }, () => {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region ON INIT AND DESTROY FUNCTIONS

            vm.$onInit = async function () {
                layoutService.onLayoutChanged(onDestroy, (info) => {
                    vm.style.subject.fontSize = info.fontSizes.textSizeL;
                    vm.style.senderInfo.fontSize = info.fontSizes.textSize;
                });

                translate();
                await loadEmail();
                loadEmailAttachments();
                loadReplyToList();
            }

            vm.onDestroy = function () {
                onDestroy.forEach((destruction) => destruction());
            }

            // #endregion ON INIT AND DESTROY FUNCTIONS

        }]
    });
})();
